import { useQuery } from '@apollo/client'
import { auth } from '../lib/auth'
import { ANNOUNCEMENT_FEED } from '../graphql/announcement-queries'
import type { Announcement } from '../types/announcement'

// One small top-slice query shared by the nav badge and the dashboard widget.
// Both call this with the same variables, so Apollo serves them from a single
// cache entry (no double-fetch). Refetches on navigation; no polling — nothing
// is pushed in real time.
const TOP_SLICE_LIMIT = 5

export interface UnreadAnnouncements {
  unreadCount: number
  // The top slice of the feed (priority→newest), used by the dashboard widget.
  announcements: Announcement[]
  loading: boolean
  refetch: () => void
}

export const useUnreadAnnouncements = (): UnreadAnnouncements => {
  const isAuthenticated = auth.isAuthenticated()

  const { data, loading, refetch } = useQuery(ANNOUNCEMENT_FEED, {
    variables: { limit: TOP_SLICE_LIMIT, offset: 0 },
    skip: !isAuthenticated,
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
  })

  const feed = data?.announcementFeed
  return {
    unreadCount: feed?.unread_count ?? 0,
    announcements: feed?.announcements ?? [],
    loading,
    refetch: () => { void refetch() },
  }
}
